import AsyncSelect from 'react-select/async';
import { MultiValue } from 'react-select';
import { SearchType } from '../../../data/__generated__/globalTypes';
import React from 'react';
import { useForecastingSettings } from '../../ForecastingContextProvider';
import { usePrimaryForecastingState } from '../ForecastingPanel';
import { selectDefaults, useAutoCompleteOptions, useForecastingFilterValidation } from './ForecastingFilters';
import ErrorTooltip from '../ErrorTooltip';
import { ReactComponent as LoadingState } from 'svg/loader.svg';

export default function City() {
    const { forecastingSettings, updateForecastingSetting } = useForecastingSettings();
    const { isPrimaryForecastingLoading } = usePrimaryForecastingState();
    const loadOptions = useAutoCompleteOptions(SearchType.CITY);
    const { loading, data } = useForecastingFilterValidation(SearchType.CITY);

    let tooltip = null;
    if (loading) {
        tooltip = <LoadingState className='inline-flex CampaignSpendOverlayLoadingState h-4 w-4 ml-1' />;
    } else {
        if (data?.filterDependencyValidation) {
            tooltip = (
                <ErrorTooltip id={'city-error-tooltip'}>
                    <div>
                        The selected cities are no longer valid. They may be part of a country or region that is no longer selected.
                    </div>
                </ErrorTooltip>
            );
        }
    }

    return (
        <div className='mt-4 w-80'>
            <div style={{flexDirection: 'row'}}>
                <label
                    htmlFor='city'
                    className='inline-block text-sm font-medium text-gray-700'
                >
                    City
                </label>
                {tooltip}
            </div>
            <AsyncSelect
                key={'city:' + JSON.stringify(forecastingSettings)}
                isDisabled={isPrimaryForecastingLoading}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                isMulti
                name='cities'
                className='basic-multi-select'
                classNamePrefix='select'
                onChange={(newValue: MultiValue<{
                    label: string,
                    value: string
                }>) => updateForecastingSetting({ cityFilter: newValue.map(c => c.value) })}
                defaultOptions
                loadOptions={loadOptions}
                defaultValue={selectDefaults(forecastingSettings.cityFilter)}
            />
        </div>
    );
}
